// src/pages/KarigarManagement/routes.jsx

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Direct imports (no lazy loading for debugging)
import KarigarDashboard from "./Dashboard/KarigarDashboard";
import KarigarListPage from "./Karigar/KarigarListPage";
import KarigarDetailPage from "./Karigar/KarigarDetailPage";
import KarigarCreatePage from "./Karigar/KarigarCreatePage";
import KarigarEditPage from "./Karigar/KarigarEditPage";
import KarigarAvailabilityPage from "./Karigar/KarigarAvailabilityPage";
import JobListPage from "./Job/JobListPage";
import JobDetailPage from "./Job/JobDetailPage";
import JobCreatePage from "./Job/JobCreatePage";
import JobAssignmentPage from "./Job/JobAssignmentPage";
import PaymentListPage from "./Payment/PaymentListPage";
import PaymentDetailPage from "./Payment/PaymentDetailPage";
import PendingPaymentsPage from "./Payment/PendingPaymentsPage";
import KarigarEarningsPage from "./Payment/KarigarEarningsPage";
import JobEditPage from "./Job/JobEditPage";

const KarigarManagementRoutes = () => {
  console.log("KarigarManagementRoutes rendered"); // Debug log

  return (
    <Routes>
      {/* Dashboard */}
      <Route index element={<KarigarDashboard />} />
      <Route path="dashboard" element={<KarigarDashboard />} />

      {/* Karigar Routes */}
      <Route path="karigars" element={<KarigarListPage />} />
      <Route path="karigars/create" element={<KarigarCreatePage />} />
      <Route path="karigars/:karigarId" element={<KarigarDetailPage />} />
      <Route path="karigars/:karigarId/edit" element={<KarigarEditPage />} />
      <Route
        path="karigars/:karigarId/availability"
        element={<KarigarAvailabilityPage />}
      />

      {/* Job Routes */}
      <Route path="jobs" element={<JobListPage />} />
      <Route path="jobs/create" element={<JobCreatePage />} />
      <Route path="jobs/:jobId" element={<JobDetailPage />} />
      <Route path="jobs/:jobId/edit" element={<JobEditPage />} />
      <Route path="jobs/:jobId/assign" element={<JobAssignmentPage />} />

      {/* Payment Routes */}
      <Route path="payments" element={<PaymentListPage />} />
      <Route path="payments/pending" element={<PendingPaymentsPage />} />
      <Route path="payments/:paymentId" element={<PaymentDetailPage />} />
      <Route
        path="payments/earnings/:karigarId"
        element={<KarigarEarningsPage />}
      />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/karigar" replace />} />
    </Routes>
  );
};

export default KarigarManagementRoutes;
